module.exports = __webpack_public_path__ + "static/media/22-mobile.a93399f9.jpg";